import { createSelector } from '@reduxjs/toolkit';

import { buildProductMedia } from 'src/components/organisms/ProductImagesCarousel/media/buildProductMedia';
import type { ReduxApplicationState } from '../combinedReducer';

export const selectProduct = (state: ReduxApplicationState) => state.product;

export const selectProductPrice = (state: ReduxApplicationState) => state.product.price;

export const selectProductPartner = (state: ReduxApplicationState) => state.product.partner;

/** @deprecated use deliveryEvent from delivery slice */
export const selectProductDeliveryByEvent = (state: ReduxApplicationState) =>
  state.product.deliveryByEvent;

export const selectProductAttributes = createSelector(
  [selectProduct],
  (product) => product.attributes,
);

export const selectProductMedia = createSelector(
  [
    (state: ReduxApplicationState) => state.product.images,
    (state: ReduxApplicationState) => state.product.video,
  ],
  buildProductMedia,
);
